import type { Dayjs } from "dayjs";

export type Presets = Array<{
    id: string;
    text: string;
    value: { from: Dayjs; to: Dayjs };
    disabled?: boolean;
    locked?: boolean;
}>;

export const IndicatorTypes = {
    PULSE: "PULSE",
    DOT: "DOT",
    NONE: "NONE",
} as const;

export type IndicatorType = keyof typeof IndicatorTypes;
